<template>
  <div :class="[$style.container, { [$style.mobile]: isMobile }]">
    <div :class="$style.header">
      <div :class="$style.icon">
        <img :src="image" :class="$style.iconImg" @error="fallbackImage" />
      </div>
      <div :class="$style.title">
        <div :class="$style.name">{{ abilityDetails.name }}</div>
        <div :class="$style.tag">Innate Ability</div>
      </div>
    </div>
    <div :class="$style.content">
      <ability-details
        :ability="innate"
        :abilityDetails="abilityDetails"
        :aghanims="{ scepter: false, shard: false }"
      />
    </div>
  </div>
</template>

<script>
import AbilityDetails from './details.vue'

export default {
  name: 'innate',
  components: { AbilityDetails },
  props: {
    innate: {
      type: String,
      required: true
    },
    hidden: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fallbackImage(e) {
      e.target.src = require('@/assets/imgs/innate.png')
    }
  },
  computed: {
    abilityDetails() {
      return this.getAbilityDetails(this.innate)
    },
    image() {
      if (this.hidden) {
        return require('@/assets/imgs/innate.png')
      }
      return this.abilityDetails.image
    }
  }
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  border-radius: 0.1rem;
  border: 0.15rem solid rgba(var(--color_black-rgb), 0.5);
  background: #1b1c26 url('~@/assets/imgs/tooltip-bg.png') center top no-repeat;
  background-size: 142%;
  box-shadow: 0 0.05rem 0.1rem rgba(var(--color_black-rgb), 0.5);

  &.mobile {
    background-size: 125%;
  }
}

.header {
  display: flex;
  height: 2.8rem;
}

.icon {
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconImg {
  width: 80%;
  border-radius: 0.2rem;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  background: url('~@/assets/imgs/facet-bg.png') left top no-repeat;
  background-size: 150%;
  padding: 0.2rem 1rem;
  gap: 0.2rem;
}

.name {
  font-family: 'Reaver';
  color: var(--color_white);
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: uppercase;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.tag {
  width: 5rem;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.5rem;
  color: #d9caa6;
  background: #4e4f4b;
  border-radius: 0.2rem;
  border: 0.05rem solid #605f57;
  padding: 0.05rem 0.1rem;
}

.content {
  padding: 0.4rem;
  position: relative;
}
</style>
